module.exports = __webpack_public_path__ + "static/media/phone.1dd48966.svg";